// extracted by mini-css-extract-plugin
export default {"root":"FieldCurrencyWithoutDecimalsInput_root__4PE2b"};